import axios from 'axios';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';

const useDeleteIdCard = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    async ({ id, complete, onSuccessCallback }) => {
      await axios.delete(`/idcards/${id}?complete=${complete}`);
    },
    {
      onSuccess: (res, { complete, onSuccessCallback }) => {
        queryClient.invalidateQueries('idCards', { exact: true });
        onSuccessCallback();
        const toastMsg = complete ? 'All ID Card versions deleted' : 'Latest ID Card version deleted';
        toast.success(toastMsg, {
          position: toast.POSITION.TOP_LEFT,
        });
      },
      onError: (err) => {
        let errorMsg = err?.response?.data?.error || err.message;
        toast.error(`${errorMsg}`, {
          position: toast.POSITION.TOP_LEFT,
        });
      },
    }
  );

  return {
    deleteIdCard: mutate,
    isLoading,
  };
};

export default useDeleteIdCard;
